import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { format } from '@e3dc-react/shell/Libs/date'

/**
 * Hook to deliver the last time data is fetched
 *
 * TODO: currently just "right now" is taken as the date displayed. Is that actually a valid solution?
 */
export const useLastTimeFetched = (): string => {
  const { t } = useCustomTranslation()
  return format(new Date(), t('common.format.date-fns-date-time'))
}
